import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#C9A227", // Gold - Primary buttons
    },
    secondary: {
      main: "#3A3F4B", // Light gray - Secondary buttons
    },
    background: {
      default: "#1C1F26", // App background
      paper: "#23262D", // Card background
    },
    text: {
      primary: "#FFFFFF", // Primary text color
      secondary: "#A5AAB5", // Secondary text color
    },
    success: {
      main: "#3EB489", // Emerald green
    },
  },
  typography: {
    fontFamily: "'Montserrat', sans-serif",
  },
});

export default theme;
